import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import config from '../../../config';
import StopOperationTable from './StopOperationTable';
import StopOperationPopup from './StopOperationPopup';
import axios from 'axios';
import AlarmModal from '../AlarmModal';

const StopOperationPage = ({ selectedDate }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // 팝업 열기 함수
  const openPopup = row => {
    setPopupContent(row);
    setIsPopupOpen(true);
  };

  // 팝업 닫기 함수
  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${config.apiUrl}/prdtStopSel.do`,
          { stdate: format(selectedDate, 'yyyyMMdd') },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;

        // resultData가 빈 배열일 때 모달 열기
        if (apiData.resultData && Array.isArray(apiData.resultData) && apiData.resultData.length === 0) {
          setModalIsOpen(true);
        }

        const transformedData = transformData(apiData);
        setData(transformedData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err.response ? err.response : err);
        setError(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate]);

  const transformData = apiData => {
    // 머신 데이터 초기화
    const machines = {
      PM2: { machin: 'PM2', data: [] },
      PM3: { machin: 'PM3', data: [] },
    };

    // 데이터 처리
    if (apiData && Array.isArray(apiData.resultData)) {
      apiData.resultData.forEach(entry => {
        const machineKey = entry.HOGIXX === '2' ? 'PM2' : entry.HOGIXX === '3' ? 'PM3' : null;

        if (machineKey) {
          machines[machineKey].data.push({
            startHour: entry.STR_HH,
            startMinute: entry.STR_MM,
            endHour: entry.END_HH,
            endMinute: entry.END_MM,
            stopspeed: entry.SPTIME,
            paperType: entry.PKCDNM,
            standardWeight: entry.BSSWGH,
            stopType: entry.STPGUM,
            stopReason: entry.STPSAM,
            place: entry.STPPLM,
            reason: entry.REMARK,
            actionHistory: entry.MEASUM,
            delayReason: entry.DELAYX,
            workingGroup: entry.WRKGRM,
          });
        }
      });

      // 데이터 반환
      return [machines.PM2, machines.PM3];
    } else {
      console.error('Expected resultData to be an array but got:', apiData.resultData);
      return [machines.PM2, machines.PM3]; // 빈 데이터가 있어도 상위 헤더는 남겨둠
    }
  };

  const columns = React.useMemo(
    () => [
      { Header: '시', accessor: 'startHour', id: 'startHour' },
      { Header: '분', accessor: 'startMinute', id: 'startMinute' },
      { Header: '시', accessor: 'endHour', id: 'endHour' },
      { Header: '분', accessor: 'endMinute', id: 'endMinute' },
      { Header: '중지시간', accessor: 'stopspeed', id: 'stopspeed' },
      { Header: '지종', accessor: 'paperType', id: 'paperType' },
      { Header: '기준평량', accessor: 'standardWeight', id: 'standardWeight' },
      { Header: '중지구분', accessor: 'stopType', id: 'stopType' },
      { Header: '중지사유', accessor: 'stopReason', id: 'stopReason' },
      { Header: '장소', accessor: 'place', id: 'place' },
      {
        Header: '내용',
        accessor: 'context',
        id: 'context',
        Cell: ({ row }) => (
          <button className='text-blue-500 underline' onClick={() => openPopup(row.original)}>
            팝업창
          </button>
        ),
      },
      { Header: '작업반', accessor: 'workingGroup', id: 'workingGroup' },
    ],
    [],
  );

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className='flex flex-col c2_text'>
      {data.map(machine => (
        <div key={machine.machin} className='mb-4'>
          <div className='change-w change_2h page_center bg-blue-200 font-bold text-blue-600'>{machine.machin}</div>
          <div className='flex whitespace-nowrap overflow-x-auto'>
            <div className='b2-r'>
              <StopOperationTable columns={columns} data={machine.data} />
            </div>
          </div>
        </div>
      ))}
      {popupContent && <StopOperationPopup isOpen={isPopupOpen} onClose={closePopup} content={popupContent} />}{' '}
      <AlarmModal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} />
    </div>
  );
};

export default StopOperationPage;
